// Draft seeded by migration 62; publication time selects the existing-account audience.
export const GAME_SERVERS_RELEASE_ID = '1560000000000000062'
export const GAME_SERVERS = [
  { key: 'dota2', name: 'Dota 2' },
  { key: 'cs2', name: 'CS 2' },
  { key: 'deadlock', name: 'Deadlock' },
  { key: 'minecraft', name: 'Minecraft' },
  { key: 'gta5rp', name: 'GTA 5 RP' },
  { key: 'roblox', name: 'Roblox' },
] as const

const seenKey = (userId: string) => `klichat.game-servers.seen.${GAME_SERVERS_RELEASE_ID}.${userId}`
export function gameServersSeen(userId: string): boolean {
  try { return localStorage.getItem(seenKey(userId)) === '1' } catch { return false }
}
export function rememberGameServers(userId: string): void {
  try { localStorage.setItem(seenKey(userId), '1') } catch { /* Server receipt remains authoritative. */ }
}
